import styled from "styled-components";
import { Switch } from "@progress/kendo-react-inputs";
import { SwitchChangeEvent } from "@progress/kendo-react-inputs/dist/npm/switch/Switch";
import PageMenuItem from "./PageMenuItem";

const StyledSwitch = styled(Switch)`
  margin-right: 0.5rem;
`;

interface Props {
  label: string;
  value: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}

export default function PageMenuSwitch({
  label,
  value,
  onChange,
  disabled = false,
}: Props) {
  return (
    <PageMenuItem disabled={disabled} align="right">
      <StyledSwitch
        offLabel=""
        onLabel=""
        size="small"
        onChange={(e: SwitchChangeEvent) => onChange?.(e.value)}
        checked={value}
      />
      <span style={{ fontSize: "14px", color: "black" }}>{label}</span>
    </PageMenuItem>
  );
}
